/**
 * TT-828 local ASR streaming transcript console logs.
 * Set LOCAL_ASR_STREAMING_TRANSCRIPT_DEBUG to stream raw ONNX output during
 * rollout debugging.
 */

/** Set true to stream raw ONNX ASR output to the console. */
const LOCAL_ASR_STREAMING_TRANSCRIPT_DEBUG = true;

/**
 * Streams local ASR raw engine output for debugging.
 * Emitted consensus text is already logged downstream as "Streaming transcript".
 * Raw output is logged only when the engine returns non-empty text.
 * @param {object} snapshot
 * @param {string} snapshot.mode
 * @param {string} snapshot.rawText
 */
export function logLocalAsrStreamingTranscript({
  mode,
  rawText,
} = {}) {
  if (!LOCAL_ASR_STREAMING_TRANSCRIPT_DEBUG) {
    return;
  }

  const trimmedRaw = rawText?.trim() || '';
  if (!trimmedRaw) {
    return;
  }

  const prefix = `[local-asr ${mode || 'phrase'}]`;
  console.log(`${prefix} raw: ${trimmedRaw}`);
}
